// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/webpack-edge/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#section-content-image .links a{margin-bottom:2em}#section-content-image .img{background-color:#959595;border:2px solid #eceded}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
